<template>
  <ag-table
    :data-source-api="getAllTaskSessionVolunteers"
    :grid-options="gridOptions"
    :permissions="permissions"
    :is-entities-response="false"
    @emitImportFromExcel="importFromExcel"
    @emitExportToExcel="exportToExcel"
    :rtl="false"
  >
    <template #action>
      <button
        class="close-button"
        @click="handleCloseTask()"
      >
        إغلاق الفرصة
      </button>
    </template>
  </ag-table>
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "../../shared/shared-components/ag-grid/AgTableServerSide.vue";
import CouponManagementInputCell from "../components/CouponManagementInputCell.vue";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";

const tasksRepo = RepositoryFactory.get("tasksRepository");

export default {
  name: "CloseTaskSession",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgButton,
    // eslint-disable-next-line vue/no-unused-components
    CouponManagementInputCell,
  },
  data() {
    return {
      apiQuery: "",
      closeTaskPayload: [],
      task: {
        incrimentalId: null,
        id: null,
        title: null,
        description: null,
        startAt: null,
        endAt: null,
        time: null,
        place: null,
        volunteeringFieldId: null,
        maxSeats: null,
        availableSeats: null,
        status: null,
        couponCode: null,
        deductCouponCode: null,
        couponPoints: null,
        deductCouponPoints: null,
        specifications: null,
        steps: null,
        image: null,
        createdAt: null,
        updatedAt: null,
        deletedAt: null,
      },
      gridApi: null,
      gridOptions: null,
      permissions: {},
    };
  },
  methods: {
    async importFromExcel(file) {
      await tasksRepo.importTaskSessionAppliedVolunteers(this.$route.params.sessionId, file.rawFile);
      this.$router.push(`/volunteers/tasks/${this.$route.params.id}/sessions`);
    },
    async exportToExcel(query = '') {
      await tasksRepo.exportTaskSessionAppliedVolunteers(this.$route.params.sessionId, query);
    },
    async handleCloseTask() {
      const taskId = this.$route.params.id;
      const sessionId = this.$route.params.sessionId;
      const payload = {
        negativePointsVolunteerIds: this.closeTaskPayload
          .filter((item) => item.point < 0)
          .map((item) => item.id),
        zeroPointsVolunteerIds: this.closeTaskPayload
          .filter((item) => item.point === 0)
          .map((item) => item.id),
      };
      await tasksRepo.completeTaskSession(sessionId, payload);
      this.$router.push(`/volunteers/tasks/${taskId}/sessions`);
    },
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "اسم المتطوع",
          field: "volunteer.name",
          filter: "agTextColumnFilter",
          sortable: true,
          width: 200,
        },
        {
          headerName: "رقم البطاقة",
          field: "volunteer.cardNumber",
          filter: "agTextColumnFilter",
          sortable: true,
          width: 200,
        },
        {
          headerName: "رابط الملف",
          field: "attachmentUrl",
          cellRendererFramework: AgButton,
          sortable: true,
          width: 200,
          valueGetter:
            function getObject(params) {
              return params.data.attachmentUrl;
            },
          cellRendererParams: () => {
            return {
              size: "small",
              color: "primary",
              name: "مشاهدة الملف",
              type: "gradient",
              click(attachmentUrl) {
                window.open(attachmentUrl, '_blank').focus();
              },
            };
          },
        },
        {
          headerName: "النقاط الممنوحة",
          field: "points",
          width: 400,
          sortable: false,
          cellRendererFramework: CouponManagementInputCell,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: (params) => {
            return {
              updatePoints: (payload) => {
                const index = self.closeTaskPayload.findIndex(
                  (p) => p.id === payload.id
                );
                if (index !== -1) {
                  self.closeTaskPayload[index] = payload;
                } else {
                  self.closeTaskPayload.push(payload);
                }
              },
              getTask: () => {
                return self.task;
              },
              getSavedPoint: (volunteerId) => {
                const savedItem = self.closeTaskPayload.find(
                  (p) => p.id === volunteerId
                );
                return savedItem ? savedItem.point : null;
              },
            };
          },
        },
      ];
    },
    async getAllTaskSessionVolunteers(query) {
      const sessionId = this.$route.params.sessionId;
      return await tasksRepo.fetchTaskSessionAppliedVolunteers(sessionId, query);
    },
  },
  async created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();

    const taskId = this.$route.params.id;
    this.task = await tasksRepo.getTask(taskId);
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>

<style scoped>
.close-button {
  cursor: pointer;
  outline: none;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  background: #85cd5f;
}
</style>
